import React from "react";

const PrivacyDark = () => {
  return (
    <svg
      width="196"
      height="79"
      viewBox="0 0 196 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M78.7623 -88.1084L81.4834 -82.2722C82.7523 -79.5506 85.997 -78.3776 88.7185 -79.6465C115.874 -92.3076 148.25 -80.6029 160.912 -53.447C173.573 -26.291 161.822 5.98704 134.666 18.6482L125.476 22.9332M117.065 -5.95606L122.414 -8.44988C134.789 -14.2197 139.967 -29.1367 133.975 -41.4058C128.118 -53.3997 113.726 -58.6723 101.569 -53.1601L91.4594 -48.576M58.211 -33.4999L55.6019 -32.3168C36.1924 -23.5159 27.6996 -0.564307 36.7052 18.7511L37.3424 20.1179C46.6294 40.0368 70.3054 48.6557 90.2243 39.3688L92.2291 38.4341"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
      <path
        d="M115.781 46.1833C107.248 50.1621 97.0566 46.4537 93.0408 37.8405C89.025 29.2273 92.7361 19.0373 101.27 15.0585C109.804 11.0797 119.995 14.7881 124.01 23.4013C128.026 32.0145 124.315 42.2045 115.781 46.1833Z"
        stroke="#E1E1E1"
        stroke-width="11.4465"
      />
      <path
        d="M71.8744 32.9837C74.8421 44.0956 78.3423 54.1895 88.2779 60.7441"
        stroke="#E1E1E1"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PrivacyDark;
